export default __webpack_public_path__ + "static/media/obstetrics_and_gynaecology.bb6da2fd.png";